import { render, staticRenderFns } from "./export-sku-tags.vue?vue&type=template&id=013947e4&"
import script from "./export-sku-tags.vue?vue&type=script&lang=js&"
export * from "./export-sku-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports